import { render, staticRenderFns } from "./_template-status.vue?vue&type=template&id=6b94533f&scoped=true&"
import script from "./_template-status.vue?vue&type=script&lang=js&"
export * from "./_template-status.vue?vue&type=script&lang=js&"
import style0 from "./_template-status.vue?vue&type=style&index=0&id=6b94533f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b94533f",
  null
  
)

export default component.exports